<template>
  <div id="page-element-setting">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchObj">
        <el-form-item label="所属页面">
          <el-input v-model="searchObj.belongs_page" placeholder="如 index" clearable style="width: 140px;" />
        </el-form-item>
        <el-form-item label="版本">
          <el-input v-model="searchObj.version" placeholder="如 1.0" clearable style="width: 100px;" />
        </el-form-item>
        <el-form-item label="uni_key">
          <el-input v-model="searchObj.uni_key" placeholder="关键字" clearable style="width: 160px;" />
        </el-form-item>
        <el-form-item label="删除状态">
          <el-select v-model="searchObj.delete_filter" style="width: 120px;">
            <el-option label="正常" value="0" />
            <el-option label="已删除" value="1" />
            <el-option label="全部" value="all" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="openEdit()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-wrap">
      <el-table size="small" :data="list">
        <el-table-column prop="id" label="ID" width="72" />
        <el-table-column prop="version" label="版本" width="80" />
        <el-table-column prop="belongs_page" label="所属页面" width="110" />
        <el-table-column prop="uni_key" label="uni_key" min-width="160" show-overflow-tooltip />
        <el-table-column label="类型" width="72">
          <template slot-scope="scope">
            {{ scope.row.element_type === 'image' ? '图片' : '文字' }}
          </template>
        </el-table-column>
        <el-table-column label="展示值" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.element_type === 'image' && scope.row.show_value"
              :src="scope.row.show_value"
              fit="cover"
              style="width: 44px; height: 44px; border-radius: 4px;"
              :preview-src-list="[scope.row.show_value]"
            />
            <span v-else>{{ scope.row.show_value }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tips_text" label="提示语" min-width="140" show-overflow-tooltip />
        <el-table-column label="提示图" width="72">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.tips_pic"
              :src="scope.row.tips_pic"
              fit="cover"
              style="width: 44px; height: 44px; border-radius: 4px;"
              :preview-src-list="[scope.row.tips_pic]"
            />
            <span v-else class="gray9">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="160" />
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <template v-if="Number(scope.row.is_delete) === 1">
              <el-button type="text" size="small" @click="restoreRow(scope.row)">恢复</el-button>
            </template>
            <template v-else>
              <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="pageChange"
      />
    </div>

    <el-dialog :title="form.id ? '编辑页面元素' : '新增页面元素'" :visible.sync="visible" width="640px" @closed="onDialogClosed">
      <el-form :model="form" label-width="100px" size="small">
        <el-form-item label="所属页面" required>
          <el-input v-model="form.belongs_page" placeholder="如 index，与前端页面文件名一致" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item label="版本" required>
          <el-input v-model="form.version" placeholder="如 1.0、2.0，与 C 端请求 version 一致" />
          <div class="form-tip">同一页面可维护多套配置；C 端拉取时传对应 <code>version</code>。</div>
        </el-form-item>
        <el-form-item label="元素类型" required>
          <el-select v-model="form.element_type" style="width: 100%;" @change="onElementTypeChange">
            <el-option label="文字" value="text" />
            <el-option label="图片" value="image" />
          </el-select>
        </el-form-item>
        <el-form-item required>
          <span slot="label">uni_key</span>
          <div class="unikey-row">
            <el-input v-model="form.uni_key" placeholder="小写字母、数字、下划线" />
            <el-button type="default" @click="fillSuggestKey">生成 key</el-button>
          </div>
          <div class="form-tip">
            命名建议：<code>{页面}_{text|image}_{用途}_{序号}</code>，如 index_text_title_001；需与前端代码常量一致。
          </div>
        </el-form-item>
        <el-form-item label="展示值" required>
          <template v-if="form.element_type === 'image'">
            <div class="pic-row">
              <el-button size="small" icon="el-icon-picture-outline" @click="openUpload('show_value')">上传图片</el-button>
              <el-image
                v-if="form.show_value"
                :src="form.show_value"
                fit="cover"
                class="pic-preview"
                :preview-src-list="[form.show_value]"
              />
            </div>
            <el-input v-model="form.show_value" class="pic-url-input" placeholder="图片 URL" clearable />
          </template>
          <el-input v-else v-model="form.show_value" type="textarea" :rows="3" placeholder="展示文案" />
        </el-form-item>
        <el-form-item label="提示语" required>
          <el-input v-model="form.tips_text" type="textarea" :rows="2" placeholder="说明该配置在业务中的位置，便于运营修改" />
        </el-form-item>
        <el-form-item label="提示配图">
          <div class="pic-row">
            <el-button size="small" icon="el-icon-picture-outline" @click="openUpload('tips_pic')">上传截图</el-button>
            <el-image
              v-if="form.tips_pic"
              :src="form.tips_pic"
              fit="cover"
              class="pic-preview"
              :preview-src-list="[form.tips_pic]"
            />
          </div>
          <el-input v-model="form.tips_pic" class="pic-url-input" placeholder="可选，截图 URL" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitSave">保存</el-button>
      </div>
    </el-dialog>

    <Upload v-if="isupload" :config="{ file_type: 'image', total: 1 }" @returnImgs="onUploadPic" />
  </div>
</template>

<script>
import PageElementApi from '@/api/pageelement'
import Upload from '@/components/file/Upload.vue'

export default {
  name: 'PageElementSetting',
  components: { Upload },
  data() {
    return {
      searchObj: {
        page: 1,
        list_rows: 15,
        belongs_page: '',
        version: '1.0',
        uni_key: '',
        delete_filter: '0',
      },
      list: [],
      total: 0,
      visible: false,
      loading: false,
      isupload: false,
      uploadTarget: 'show_value',
      form: {
        id: null,
        belongs_page: '',
        version: '1.0',
        uni_key: '',
        element_type: 'text',
        show_value: '',
        tips_text: '',
        tips_pic: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      PageElementApi.index(this.searchObj, true).then((res) => {
        const list = res.data.list
        this.list = list.data
        this.total = list.total
      })
    },
    pageChange(page) {
      this.searchObj.page = page
      this.getData()
    },
    openEdit(row) {
      if (row) {
        this.form = {
          id: row.id,
          belongs_page: row.belongs_page || '',
          version: row.version || '1.0',
          uni_key: row.uni_key || '',
          element_type: row.element_type === 'image' ? 'image' : 'text',
          show_value: row.show_value || '',
          tips_text: row.tips_text || '',
          tips_pic: row.tips_pic || '',
        }
      } else {
        this.form = {
          id: null,
          belongs_page: this.searchObj.belongs_page || '',
          version: (this.searchObj.version || '1.0').trim() || '1.0',
          uni_key: '',
          element_type: 'text',
          show_value: '',
          tips_text: '',
          tips_pic: '',
        }
      }
      this.visible = true
    },
    onDialogClosed() {
      this.isupload = false
    },
    onElementTypeChange() {
      // 切换类型时保留 show_value，由运营自行调整
    },
    fillSuggestKey() {
      const page = (this.form.belongs_page || '').trim()
      if (!page) {
        this.$message.warning('请先填写所属页面')
        return
      }
      PageElementApi.suggestKey(
        {
          belongs_page: page,
          element_type: this.form.element_type,
          version: (this.form.version || '1.0').trim() || '1.0',
        },
        true
      ).then((res) => {
        const k = res.data && res.data.uni_key
        if (k) {
          this.form.uni_key = k
        }
      })
    },
    openUpload(target) {
      this.uploadTarget = target
      this.isupload = true
    },
    onUploadPic(imgs) {
      this.isupload = false
      if (imgs && imgs.length && imgs[0].file_path) {
        this.form[this.uploadTarget] = imgs[0].file_path
      }
    },
    submitSave() {
      const f = this.form
      if (!f.belongs_page || !f.version || !f.uni_key || !f.show_value || !f.tips_text) {
        this.$message.error('请填写必填项：所属页面、版本、uni_key、展示值、提示语')
        return
      }
      if (!/^[a-z0-9_]+$/.test(String(f.uni_key).toLowerCase())) {
        this.$message.error('uni_key 仅允许小写字母、数字、下划线')
        return
      }
      this.loading = true
      const payload = { ...f, uni_key: String(f.uni_key).toLowerCase().trim() }
      const api = f.id ? PageElementApi.edit : PageElementApi.add
      api(payload, true)
        .then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.getData()
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteRow(row) {
      this.$confirm('确定删除该配置吗？（软删，可在「已删除」中恢复）', '提示', {
        type: 'warning',
      })
        .then(() => {
          return PageElementApi.delete({ id: row.id }, true)
        })
        .then(() => {
          this.$message.success('已删除')
          this.getData()
        })
        .catch(() => {})
    },
    restoreRow(row) {
      this.$confirm('确定恢复该配置吗？', '提示', { type: 'warning' })
        .then(() => PageElementApi.restore({ id: row.id }, true))
        .then(() => {
          this.$message.success('已恢复')
          this.getData()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrap {
  margin-top: 10px;
}
.pagination {
  margin-top: 15px;
  text-align: right;
}
.gray9 {
  color: #999;
  font-size: 12px;
}
.unikey-row {
  display: flex;
  gap: 8px;
  align-items: center;
  .el-input {
    flex: 1;
  }
}
.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  code {
    font-size: 11px;
    background: #f4f4f5;
    padding: 2px 6px;
    border-radius: 3px;
  }
}
.pic-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.pic-preview {
  width: 56px;
  height: 56px;
  border-radius: 4px;
}
.pic-url-input {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/pageelement/index.vue